import React, { useState, useEffect } from 'react'
import { LoaderSpinner } from '../../components/LoaderSpinner';
import { Link } from 'react-router-dom'
import $ from 'jquery'

import { useSelector, useDispatch } from 'react-redux';
import { obtenerCliente } from '../../actions/clientesActions';
import { obtenerClienteHistoryAction } from '../../actions/clientesActions';
import { obtenerClientsFieldsAction } from '../../actions/customFieldsActions';
import { InteractionHistory } from '../../components/contact-history/InteractionHistory';

function FieldRow({ label, value }) {
    return (
        <div className="mb-3">
            <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600 }}>
                {label}
            </div>
            <div style={{ fontSize: 15, color: '#2c3e50', marginTop: 2 }}>
                {value || <span style={{ color: '#bbb' }}>—</span>}
            </div>
        </div>
    );
}

const isValidValue = (v) => v != null && v !== '' && String(v) !== 'null';

function TagPills({ tags }) {
    const valid = Array.isArray(tags) ? tags.filter(isValidValue) : [];
    if (valid.length === 0) {
        return <span style={{ color: '#bbb' }}>—</span>;
    }
    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
            {valid.map((tag, i) => (
                <span key={i} style={{
                    background: '#f0f2f5',
                    borderRadius: 12,
                    padding: '2px 10px',
                    fontSize: 13,
                    color: '#555'
                }}>
                    {tag}
                </span>
            ))}
        </div>
    );
}

function MailList({ mails }) {
    const valid = Array.isArray(mails) ? mails.filter(isValidValue) : [];
    if (valid.length === 0) {
        return <span style={{ color: '#bbb' }}>—</span>;
    }
    return (
        <div>
            {valid.map((mail, i) => (
                <div key={i} style={{ fontSize: 15, color: '#2c3e50' }}>{mail}</div>
            ))}
        </div>
    );
}

export const ViewClient = () => {
    const [clientId, setClientId] = useState(null);
    const dispatch = useDispatch();

    const loading = useSelector(state => state.clientes.loading);
    const clienteSearch = useSelector(state => state.clientes.clientedit);
    const search_custom_page = useSelector(state => state.landings.search_custom_page);
    const clientsfieldsCustom = useSelector(state => state.customFields.clientsfields.custom);
    const clientsfields = useSelector(state => state.customFields.clientsfields.normal);
    const clientHistory = useSelector(state => state.clientes.clientHistory);
    const historyLoading = useSelector(state => state.clientes.historyLoading);
    const historyError = useSelector(state => state.clientes.historyError);

    const [cliente, setCliente] = useState({
        nombre: '',
        apellido: '',
        razon_social: '',
        mail: [],
        telefono: [],
        web: '',
        comentario: '',
        estado: '',
        visibilidad: '',
        tags: [],
        origen: [],
        unsubcribe: ''
    });

    useEffect(async () => {
        await dispatch(obtenerClientsFieldsAction());
        const idTrozos = window.location.pathname.split('/');
        if (idTrozos.length == 3) {
            setClientId(idTrozos[2]);
        }
        if (clientId && clienteSearch === null) {
            dispatch(obtenerCliente(clientId));
        }
        if (clienteSearch) {
            setCliente(clienteSearch);
        }
        if (search_custom_page == null) {
            $('#loading').hide();
        }
    }, [clientId, clienteSearch, search_custom_page]);

    useEffect(() => {
        if (clientId) {
            dispatch(obtenerClienteHistoryAction(clientId));
        }
    }, [clientId]);

    const fieldName = (index, fallback) =>
        (clientsfields && clientsfields.length > index && clientsfields[index]?.custom_name)
            ? clientsfields[index].custom_name
            : fallback;

    const nombre = [cliente.nombre, cliente.apellido].filter(Boolean).join(' ') || cliente.razon_social || '—';

    return (
        <div className="white_box QA_section card_height_100">
            <div className="p-4 d-flex align-items-center justify-content-between" style={{ borderBottom: '1px solid #f0f2f5' }}>
                <span className="naranja" style={{ fontSize: 18, fontWeight: 700 }}>Perfil de Cliente</span>
                <Link to="/clients" className="colorsito" style={{ fontSize: 13 }}>← Volver</Link>
            </div>

            {loading ? <LoaderSpinner /> : null}

            <div className="p-4">
                {/* Header */}
                <div className="mb-4 pb-3" style={{ borderBottom: '1px solid #f0f2f5' }}>
                    <h5 style={{ fontWeight: 700, color: '#2c3e50', marginBottom: 4 }}>{nombre}</h5>
                    {cliente.razon_social && (cliente.nombre || cliente.apellido) && (
                        <div style={{ color: '#888', fontSize: 13 }}>{cliente.razon_social}</div>
                    )}
                    {cliente.estado ? (
                        <span style={{
                            display: 'inline-block',
                            marginTop: 8,
                            padding: '2px 12px',
                            borderRadius: 12,
                            fontSize: 12,
                            background: cliente.estado === 'activo' ? '#d4edda' : '#f8d7da',
                            color: cliente.estado === 'activo' ? '#155724' : '#721c24'
                        }}>
                            {cliente.estado === 'activo' ? 'Activo' : cliente.estado === 'bloqueado' ? 'Bloqueado' : 'Papelera'}
                        </span>
                    ) : null}
                </div>

                {/* Datos principales */}
                <div className="mb-4">
                    <h6 style={{ fontWeight: 700, color: '#2c3e50', marginBottom: 16 }}>Datos principales</h6>
                    <div className="row">
                        <div className="col-md-6">
                            <FieldRow label={fieldName(0, 'Nombre')} value={cliente.nombre} />
                            <FieldRow label={fieldName(1, 'Apellido')} value={cliente.apellido} />
                            <FieldRow label={fieldName(2, 'Razón Social')} value={cliente.razon_social} />
                            <div className="mb-3">
                                <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600 }}>
                                    {fieldName(3, 'Email')}
                                </div>
                                <div style={{ marginTop: 2 }}>
                                    <MailList mails={cliente.mail} />
                                </div>
                            </div>
                            <div className="mb-3">
                                <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600 }}>
                                    {fieldName(4, 'Teléfono')}
                                </div>
                                <div style={{ marginTop: 2 }}>
                                    <MailList mails={cliente.telefono} />
                                </div>
                            </div>
                            <FieldRow label={fieldName(5, 'Web')} value={cliente.web} />
                            <FieldRow label="Suscripción" value={cliente.unsubcribe} />
                        </div>
                        <div className="col-md-6">
                            <FieldRow label={fieldName(6, 'Comentario')} value={cliente.comentario} />
                            <div className="mb-3">
                                <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600 }}>
                                    {fieldName(7, 'Tags')}
                                </div>
                                <div style={{ marginTop: 6 }}>
                                    <TagPills tags={cliente.tags} />
                                </div>
                            </div>
                            <div className="mb-3">
                                <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600 }}>
                                    {fieldName(8, 'Origen')}
                                </div>
                                <div style={{ marginTop: 6 }}>
                                    <TagPills tags={cliente.origen} />
                                </div>
                            </div>
                            <FieldRow label={fieldName(9, 'Estado')} value={
                                cliente.estado === 'activo' ? 'Activo'
                                : cliente.estado === 'bloqueado' ? 'Bloqueado'
                                : cliente.estado === 'papelera' ? 'Papelera'
                                : cliente.estado
                            } />
                            <FieldRow label={fieldName(10, 'Visibilidad')} value={cliente.visibilidad} />

                            {clientsfieldsCustom && clientsfieldsCustom.length > 0 && clientsfieldsCustom.map((input, i) => (
                                <div key={i} className="mb-3">
                                    <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600 }}>
                                        {input.name}
                                    </div>
                                    <div style={{ fontSize: 15, color: '#2c3e50', marginTop: 2 }}>
                                        {input.type !== 'text'
                                            ? <TagPills tags={cliente.custom && Array.isArray(cliente.custom[input.name]) ? cliente.custom[input.name] : []} />
                                            : (cliente.custom ? cliente.custom[input.name] : '') || <span style={{ color: '#bbb' }}>—</span>
                                        }
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Historial de interacciones */}
                <InteractionHistory
                    summary={clientHistory ? clientHistory.summary : null}
                    events={clientHistory ? clientHistory.events : null}
                    loading={historyLoading}
                    error={historyError}
                    emptyMessage="Este cliente aún no registra interacciones de campañas o formularios."
                />
            </div>
        </div>
    );
};
